import React from 'react';
import { Link } from 'react-scroll';
import { useLanguage } from '../../i18n/LanguageContext';

const CtaSection = () => {
  const { t } = useLanguage();
  return (
    <div className="upper-contact-area" style={{ background: '#0d1117', borderTop: '1px solid #1e293b', padding: '60px 0' }}>
      <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '24px' }}>
          <h2 style={{ color: '#f1f5f9', fontSize: 'clamp(20px, 3vw, 28px)', fontWeight: 700, margin: 0, maxWidth: '600px', lineHeight: 1.3 }}>
            {t.cta?.title}
          </h2>
          <Link
            className="theme-btn"
            to="contact"
            spy smooth duration={500}
            style={{ flexShrink: 0, cursor: 'pointer' }}
          >
            {t.cta?.button}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
